import Gl from "@/webgl/Gl";
import State from "@/lib/hey";

export function getWebglValues(dataset) {
  const { color = 0, model = "cursor", scene = "full-with-model" } = dataset;
  State.WEBGL_DATA = { color, model, scene };
  return { color, model, scene };
}

export default function webgl(element, dataset) {
  const { color, model, scene } = getWebglValues(dataset);

  State.WEBGL_SCENE = dataset.scene;
  const canvas = element.querySelector("canvas");
  window.WEBGL_CANVAS = canvas;

  // Store original canvas reference
  const originalCanvas = canvas;

  /* 
    Init Webgl
  */
  const gl = new Gl({
    canvas: '[data-gl="canvas"]',
  });
  gl.load().then(() => {
    // State.webgl_assets_loaded = true;
  });

  // Create intersection observer to detect when element is in view
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          getWebglValues(dataset);

          // Restore canvas if it's not already in the element
          if (
            !element.contains(originalCanvas) &&
            originalCanvas &&
            !element.querySelector("canvas")
          ) {
            element.appendChild(originalCanvas);
            window.WEBGL_CANVAS = originalCanvas;
          }

          State.CANVAS_CONTAINER = element;
        } else {
          // Remove canvas when out of view to save resources
          if (element.contains(originalCanvas) && originalCanvas) {
            originalCanvas.remove();
          }
        }
      });
    },
    {
      // Optional: configure threshold and root margin
      threshold: 0.01, // Trigger when 10% of element is visible
      rootMargin: "0px", // No margin around the root
    }
  );

  // Start observing the element itself
  observer.observe(element);
}
